import apiClient from "QueryClient/axiosClient";

export const AUTH_RESPONSE_CONTRACT_ERROR = "AUTH_RESPONSE_CONTRACT_ERROR";

const requireNonEmptyString = (value, field) => {
  if (typeof value !== "string" || value.trim().length === 0) {
    const error = new Error(`Authentication response is missing ${field}`);
    error.code = AUTH_RESPONSE_CONTRACT_ERROR;
    throw error;
  }
  return value.trim();
};

export const normalizeAuthResponse = (authData) => {
  if (!authData || typeof authData !== "object" || Array.isArray(authData)) {
    const error = new Error("Authentication response is invalid");
    error.code = AUTH_RESPONSE_CONTRACT_ERROR;
    throw error;
  }

  return {
    ...authData,
    accessToken: requireNonEmptyString(authData.accessToken, "accessToken"),
    id: requireNonEmptyString(authData.id, "id"),
    email: requireNonEmptyString(authData.email, "email"),
  };
};

const normalizeAuthApiResponse = (response) => ({
  ...response,
  data: normalizeAuthResponse(response?.data),
});

export const registerNewUserViaGoogle = (data = {}) => {
  const { correlationId, ...payload } = data;
  return apiClient
    .post("/auth/registerWithGoogleLogin", payload, {
      headers: correlationId ? { "X-Request-ID": correlationId } : {},
    })
    .then(normalizeAuthApiResponse);
};

export const loginUserWithGoogleToken = (data = {}) => {
  const { correlationId, ...payload } = data;
  return apiClient
    .post("/auth/loginWithGoogle", payload, {
      headers: correlationId ? { "X-Request-ID": correlationId } : {},
    })
    .then(normalizeAuthApiResponse);
};

export const refreshUserSession = () =>
  apiClient.get("/auth/login").then(normalizeAuthApiResponse);

export const logoutUser = () => {
  return apiClient.post("/auth/logout");
};
